export default "__VITE_ASSET__BP$lgWtV__"